import {Component, Input, OnChanges, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterLink} from "@angular/router";
import {BlogDetails} from "../interface/blog-details";
import {ContentPreview} from "../interface/content-preview";
import {NextContentDetails} from "../interface/next-content-details";
import {PreviousContentDetails} from "../interface/previous-content-details";

@Component({
	selector: 'fb-blog-details-about',
	standalone: true,
	imports: [CommonModule, RouterLink],
	templateUrl: './blog-details-about.component.html',
	styleUrls: ['./blog-details-about.component.scss']
})
export class BlogDetailsAboutComponent implements OnChanges {

	@Input()
	public blogDetails: BlogDetails = {} as BlogDetails;

	@Input()
	public blogRecommendedList: ContentPreview[] = [];

	@Input()
	public contentTypeUrl: string = '/blogs/'

	ngOnChanges() {
		this.blogRecommendedList.forEach(blog => {
			if(this.blogDetails.nextBlogDetails && this.blogDetails.nextBlogDetails.id === blog.id) {
				this.blogDetails.nextBlogDetails = {} as NextContentDetails;
			}
			if(this.blogDetails.previousBlogDetails && this.blogDetails.previousBlogDetails.id === blog.id) {
				this.blogDetails.previousBlogDetails = {} as PreviousContentDetails;
			}
		})
	}
}
